/* eslint-disable space-before-function-paren */

import 'es6-object-assign';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
// import '@marketing/web-dev-react-components/dist/index.css';

function displayMessage(event) {
  if (event.message) {
    // console.log(event.message);
  } else {
    // console.log('no url');
  }
}
if (window.addEventListener) {

  window.addEventListener('onmessage', displayMessage);
} else {
  window.attachEvent('onmessage', displayMessage);
}
ReactDOM.render(<App />, document.getElementById('appRoot'));

